import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatSortable, MatTableDataSource, Sort } from '@angular/material';
import { AppConfig } from '../../../../_helpers/index';
import { PartialInvoiceData } from '../../../../_models/index';

@Component({
  selector: 'app-amortizations-table',
  templateUrl: './amortizations-table.component.html',
  styleUrls: ['./amortizations-table.component.css', '../../../../../assets/css/customer-list-table.css']
})
export class AmortizationsTableComponent implements OnInit {

  partialPaymentsListDataSource: MatTableDataSource<PartialInvoiceData> = new MatTableDataSource([]);
  displayedColumnsCreditsMade: string[];

  pageSize: number;
  PageSizeOptions: number[];

  @Input() tableData: PartialInvoiceData[];
  @Input() tableHeaders: string[];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor() { 
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
  }

  ngOnInit() {
    this.partialPaymentsListDataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.sort.sort(({ id: 'created', start: 'desc'}) as MatSortable);
    this.partialPaymentsListDataSource.sort = this.sort;
    this.partialPaymentsListDataSource.paginator = this.paginator;
  }

  ngOnChanges() {
    if (this.tableData !== undefined && this.tableHeaders !== undefined) {
      this.partialPaymentsListDataSource.data = this.tableData;
      this.displayedColumnsCreditsMade = this.tableHeaders;
    }
  }

  getProperty(obj, path) {
    return path.split('.').reduce((o, p) => o && o[p], obj);
  }
}
